import type { Mission } from '../missions.ts'

export const peace_corps: Mission = {
  id: "peace-corps",
  name: "Peace Corps",
  short: "Peace Corps",
  call: "Peace",
  kind: "independent",
  url: "https://www.peacecorps.gov/",
  established: 1961,
  palette: {
    primary: "#002147",
    secondary: "#b71234",
    accent: "#053c79",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://files.peacecorps.gov/documents/Peace_Corps_Brand_Identity_Guidelines.pdf",
  },
  motif: "dove",
  mission: {
    text: "The mission of the Peace Corps is to put purpose, passion, and skills to work for America and the world.",
    url: "https://www.peacecorps.gov/what-we-do/our-mission/",
  },
  fact: {
    text: "President Kennedy signed the executive order establishing the Peace Corps on March 1, 1961.",
    url: "https://www.peacecorps.gov/about-the-agency/history/founding-moment/",
  },
  seal: {
    file: "public/seals/peace-corps.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-Official-PeaceCorps-Logo.svg",
  },
  logo: {
    file: "public/logos/peace-corps.svg",
    source: "https://commons.wikimedia.org/wiki/File:Peace_corps_logo16.svg",
  },
  identifier: {
    about: "https://www.peacecorps.gov/about-the-agency/",
    accessibility: "https://www.peacecorps.gov/about-the-agency/working-at-the-peace-corps/accessibility-statement/",
    foia: "https://www.peacecorps.gov/about-the-agency/foia/",
    noFear: "https://www.peacecorps.gov/about-the-agency/working-at-the-peace-corps/equal-employment-opportunity/no-fear-act/",
    oig: "https://www.peacecorpsoig.gov/",
    performance: "https://www.peacecorps.gov/about-the-agency/policies-and-publications/budget-and-performance/",
    privacy: "https://www.peacecorps.gov/about-the-agency/policies-and-publications/privacy-policy/",
  },
  media: {
    photos: [
      {
        file: "/media/peace-corps-nepal-temple.jpg",
        small: "/media/peace-corps-nepal-temple-sm.jpg",
        alt: "Brick temple spires in Nepal with harvested rice spread to dry in front",
        title: "Dsc00038 Nepal",
        creator: "Peace Corps",
        source: "https://commons.wikimedia.org/wiki/File:Dsc00038_Nepal_(7986279438).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/peace-corps-cambodia-lotus.jpg",
        small: "/media/peace-corps-cambodia-lotus-sm.jpg",
        alt: "A lotus pond with broad green leaves and pink blossoms in Cambodia",
        title: "Lotus pond in Cambodia",
        creator: "Peace Corps",
        source: "https://commons.wikimedia.org/wiki/File:CBD-2007-D034_Lotus_pond_in_Cambodia.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
